import { gql } from '@apollo/client'

/**
 * This mutation is used to log a user's "activity" which under the hood logs the user's IP address and other metadata
 */
export const ACTIVITY = gql`
  mutation Activity {
    activity {
      id
    }
  }
`

/**
 * Mutation to create a user
 */
export const CREATE_USER = gql`
  mutation CreateUser($userID: ID!, $emailOrPhone: String!, $createdVia: CreatedVia!) {
    createUser(input: { id: $userID, emailOrPhone: $emailOrPhone, createdVia: $createdVia }) {
      id
    }
  }
`

/**
 * Create chat user mutation
 * @param id user's uuid
 * @param email user's email
 * @param phone user's phone
 */
export const CREATE_CHAT_USER = gql`
  mutation CreateChatUser($id: ID!, $email: String, $phone: String) {
    createChatUser(input: { id: $id, email: $email, phone: $phone }) {
      id
    }
  }
`

/**
 * Mutation to invite a user to join the workspace
 */
export const INVITE_USER_TO_WORKSPACE = gql`
  mutation InviteUserToWorkspace(
    $userID: ID!
    $accessType: MembershipAccessType!
    $email: String
    $countryCode: String
    $phone: String
    $invitedByID: ID!
    $workspaceID: ID!
  ) {
    inviteUserToWorkspace(
      input: {
        accessType: $accessType
        userID: $userID
        email: $email
        countryCode: $countryCode
        phone: $phone
        invitedByID: $invitedByID
        workspaceID: $workspaceID
      }
    ) {
      id
    }
  }
`

/**
 * Mutation to deactivate user account
 */
export const DEACTIVATE_USER_ACCOUNT = gql`
  mutation {
    deactivateUserAccount {
      id
    }
  }
`

/**
 * Mutation to update user email
 */
export const UPDATE_USER_EMAIL = gql`
  mutation UpdateUserEmail($email: String!) {
    updateUserEmail(input: { email: $email }) {
      id
    }
  }
`

/**
 * Mutation to verify updated email with OTP
 */
export const VERIFY_UPDATED_EMAIL = gql`
  mutation VerifyUpdatedEmail($email: String!, $code: String!) {
    verifyUpdatedEmail(input: { email: $email, code: $code }) {
      id
    }
  }
`

/**
 * Mutation to update user phone number
 */
export const UPDATE_USER_PHONE_NUMBER = gql`
  mutation UpdateUserPhoneNumber($phone: String!, $countryCode: String!) {
    updateUserPhoneNumber(input: { phone: $phone, countryCode: $countryCode }) {
      id
    }
  }
`

/**
 * Mutation to verify updated phone number with OTP
 */
export const VERIFY_UPDATED_PHONE_NUMBER = gql`
  mutation VerifyUpdatedPhoneNumber($phone: String!, $countryCode: String!, $code: String!) {
    verifyUpdatedPhoneNumber(input: { phone: $phone, countryCode: $countryCode, code: $code }) {
      id
    }
  }
`

/**
 * Mutation to update user details
 */
export const UPDATE_USER_DETAILS = gql`
  mutation UpdateUserDetails($name: String!, $role: UserRole) {
    updateUserDetails(input: { name: $name, role: $role }) {
      id
      name
      role
    }
  }
`
